import { render, staticRenderFns } from "./TheUserBlock.vue?vue&type=template&id=f3012678&"
import script from "./TheUserBlock.vue?vue&type=script&lang=js&"
export * from "./TheUserBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports